export function calcPageByProgress({
  newProgress,
  totalPage,
  isTwoPageLayout,
}: {
  newProgress: number;
  totalPage: number;
  isTwoPageLayout?: boolean;
}) {
  const newPage = Math.round((totalPage - 1) * newProgress) + 1;
  if (isTwoPageLayout && newPage % 2 === 0) {
    const notRoundPage = (totalPage - 1) * newProgress + 1;
    const roundDiff = notRoundPage - newPage;
    return roundDiff < 0 ? newPage - 1 : newPage + 1;
  }
  return newPage;
}
